import "../src/App.css";
import Routing from "./Main_APP/Routing";
const App = () => {
  return (
    <section className="App">
      <div className="container">
        <Routing />
      </div>
    </section>
  );
};

export default App;
